<template>
  <div>

    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>User Management</el-breadcrumb-item>
<!--          <el-breadcrumb-item>Project</el-breadcrumb-item>-->
        </el-breadcrumb>
      </el-col>
      <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
        Updating Time: {{ this.updateTime }}
        </el-col> -->
    </el-row>

    <el-card>
      <el-form :model="user" class="demo-form-inline">

      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserManagement'
}
</script>

<style scoped>

</style>
